import * as Long from "long";
import * as React from "react";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { ContractRewardItem } from "./ContractRewardItem";
export var ContractReward = React.memo(function (_a) {
    var item = _a.item, pvpUnitsMin = _a.pvpUnitsMin, pvpUnitsMax = _a.pvpUnitsMax;
    var rewardsFromContract = getContractRewards(item);
    var xpAmounts = getContractXp(item);
    var renderedPvpUnits = [getContractUnits(pvpUnitsMin, pvpUnitsMax)];
    return (React.createElement(React.Fragment, null,
        rewardsFromContract,
        xpAmounts,
        renderedPvpUnits));
});
var getContractXp = function (item) {
    var adventureXp = item.adventureXp, buffAdventureXpAmount = item.buffAdventureXpAmount, buffPlayerXpAmount = item.buffPlayerXpAmount, playerXp = item.playerXp, marketXp = item.marketXp, buffMarketXpAmount = item.buffMarketXpAmount;
    var xpValues = [];
    addContractRewardItem(xpValues, IdIcon.MarketXpIcn, marketXp, buffMarketXpAmount);
    addContractRewardItem(xpValues, IdIcon.XpAdventureIcn, adventureXp, buffAdventureXpAmount);
    addContractRewardItem(xpValues, IdIcon.XpIcn, playerXp, buffPlayerXpAmount);
    return xpValues;
};
var getContractRewards = function (item) {
    var rewards = item.rewards;
    return rewards.map(function (other) {
        var resourceIcon = getResourceIcon(other);
        return getContractRewardItem(resourceIcon, other.amount.low, other.buffAmount);
    });
};
var addContractRewardItem = function (xpValues, iconId, amount, buff) {
    if (Long.fromValue(amount)
        .add(buff || Long.ZERO)
        .greaterThan(0)) {
        xpValues.push(getContractRewardItem(iconId, amount, buff));
    }
};
var getContractRewardItem = function (iconId, amount, buff) { return (React.createElement(ContractRewardItem, { icon: iconId, buff: buff },
    React.createElement(NumberFormat, { amount: amount }))); };
var getContractUnits = function (min, max) {
    if (max === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(ContractRewardItem, { icon: IdIcon.BeeIcn },
        React.createElement(NumberFormat, { amount: min }),
        React.createElement(NumberFormat, { amount: max, format: TypeNumberFormat.Subtract })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/ContractReward.tsx
// module id = 2713
// module chunks = 3